<a class="btn icon-l icon-left {{#if item.active}}ui-icon-check{{/if}} split-1">
    <h3>Ref : {{item.reference}}</h3>
    <p>{{item.satelliteProviderName}}</p>
</a>